module.exports = __webpack_public_path__ + "img/coffee.be5030ca.webp";